// import React, { Component, useEffect, useState } from 'react';
// import getEntityList from './EntityListGridConfig';
// import LoadingWrapper from '../../Shared/LoadingWrapper';
// import CommonTable from '../../Shared/Tables';
// import ReactPagination from '../../Shared/Pagination';
// import TableHeader from '../../Shared/TableHeader';
// import { useLocation, useNavigate } from 'react-router-dom';
// import APIService from '../../../Services/APIService';
// import { Button } from 'react-bootstrap';
// import readXlsxFile from 'read-excel-file';
// import SweetAlert from '../../Shared/Notification/index';
// import { BackButton } from '../../Shared/BackButton';

// // export default EntityList;
// export default function EntityList(props) {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { supplier_type, city } = location.state;
//   const [entityDetails, setEntityDetails] = useState([]);
//   const [isDataFetched, setIsDataFetched] = useState(false);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalSize, setTotalSize] = useState(0); // Total number of records

//   const getEntityDetails = async () => {
//     let res = await APIService.get(
//       `v0/ui/ops/supplier-list/${supplier_type}/?city=${city}&page=${currentPage + 1}`
//     );
//     if (res.status == 200) {
//       let entityData = res?.data;
//       if (res?.data?.length > 0) entityData.map((v) => ({ ...v, supplierTypeCode: supplier_type }));
//       setTotalSize(res?.count);
//       setEntityDetails(entityData);
//       setIsDataFetched(true);
//     }
//     setIsDataFetched(true);
//   };

//   const handleTableChange = (page, sizePerPage) => {
//     setCurrentPage(page.selected);
//     // setPageSize(sizePerPage);
//   };

//   const fileUpload = (e) => {
//     try {
//       let fileSelect = e.target.files[0];
//       readXlsxFile(fileSelect)
//         .then((rows) => {
//           let fileData = [];
//           if (rows && rows.length > 1) {
//             let header = rows[0];
//             for (let i = 1; i < rows.length; i++) {
//               let obj = {};
//               let currentline = rows[i];
//               for (let j = 0; j < header.length; j++) {
//                 obj[header[j]] = currentline[j];
//               }
//               fileData.push(obj);
//             }
//           }
//           fetchSupplierData(fileData);
//         })
//         .catch((error) => {
//           console.error('Error reading Excel file:', error);
//         });
//     } catch {
//       console.log('Remove file');
//     }
//   };

//   const fetchSupplierData = async (fileData) => {
//     let res = await APIService.post(`/v0/ui/website/update-supplier-data/`, fileData);
//     if (res.status == 200) SweetAlert(res?.data?.data, 'success');
//   };
//   const downloadSupplierData = () => {
//     window.location.href = `${process.env.REACT_APP_API_URL}/v0/ui/mca-bot/download-entity-city-wise/?supplier_type=${supplier_type}&city=${city}`;
//   };

//   useEffect(() => {
//     getEntityDetails();
//   }, [currentPage]);
//   const backButton = () => {
//     return (
//       <BackButton
//         onClick={() =>
//           navigate(`/r/operations-dashboard/city/${supplier_type}`, {
//             state: { supplier_type: supplier_type, name: supplier_type },
//           })
//         }
//       />
//     );
//   };

//   return (
//     <>
//       <div className="page-title-header">
//         <div className="page-title-action-left">
//           {backButton()}
//           <h4>
//             List of {supplier_type} Entities of {city}
//           </h4>
//         </div>
//         {/* <div className="page-title-center">
         
//         </div> */}
//         <div className="page-title-header-right">
//           <div className="upload-wrapper">
//             <label>Upload Area/Subarea Excel </label>
//             <div className="input_container" title="Upload Area/Subarea Excel">
//               <input type="file" id="upload_file" onChange={(e) => fileUpload(e)} />
//             </div>
//           </div>
//           <div>
//             <Button
//               color="primary"
//               onClick={() => {
//                 downloadSupplierData();
//               }}
//             >
//               Export CSV
//             </Button>
//           </div>
//         </div>
//       </div>
//       <div>
//         {isDataFetched ? (
//           <div>
//             <CommonTable
//               id={'supplier_id'}
//               columnsData={getEntityList(entityDetails)}
//               rowData={entityDetails}
//             />
//             <ReactPagination
//               pageNo={currentPage}
//               pageSize={10}
//               totalItems={totalSize}
//               onPageChange={handleTableChange}
//             />
//           </div>
//         ) : (
//           <LoadingWrapper />
//         )}
//       </div>
//     </>
//   );
// }














import React, { useEffect, useState } from 'react';
import getEntityList from './EntityListGridConfig';
import LoadingWrapper from '../../Shared/LoadingWrapper';
import CommonTable from '../../Shared/Tables';
import ReactPagination from '../../Shared/Pagination';
import TableHeader from '../../Shared/TableHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import APIService from '../../../Services/APIService';
import { Button } from 'react-bootstrap';
import readXlsxFile from 'read-excel-file';
import SweetAlert from '../../Shared/Notification/index';
import { BackButton } from '../../Shared/BackButton';

export default function EntityList(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const { supplier_type, city } = location.state;
  const [entityDetails, setEntityDetails] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalSize, setTotalSize] = useState(0); 

  const getEntityDetails = async () => {
    let res = await APIService.get(
      `v0/ui/ops/supplier-list/${supplier_type}/?city=${city}&page=${currentPage + 1}`
    );
    if (res.status === 200) {
      let entityData = res.data;
      if (res.data.length > 0) {
        entityData = entityData.map((v) => ({ ...v, supplierTypeCode: supplier_type }));
      }
      setTotalSize(res.count);
      setEntityDetails(entityData);
      setIsDataFetched(true);
    }
    setIsDataFetched(true);
  };

  const handleTableChange = (page) => {
    setCurrentPage(page.selected);
  };

  const fileUpload = (e) => {
    try {
      let fileSelect = e.target.files[0];
      readXlsxFile(fileSelect)
        .then((rows) => {
          let fileData = [];
          if (rows && rows.length > 1) {
            let header = rows[0];
            for (let i = 1; i < rows.length; i++) {
              let obj = {};
              let currentline = rows[i];
              for (let j = 0; j < header.length; j++) {
                obj[header[j]] = currentline[j];
              }
              fileData.push(obj);
            }
          }
          fetchSupplierData(fileData);
        })
        .catch((error) => {
          console.error('Error reading Excel file:', error);
        });
    } catch {
      console.log('Remove file');
    }
  };

  const fetchSupplierData = async (fileData) => {
    let res = await APIService.post(`/v0/ui/website/update-supplier-data/`, fileData);
    if (res.status === 200) SweetAlert(res.data.data, 'success');
  };

  const downloadSupplierData = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/v0/ui/mca-bot/download-entity-city-wise/?supplier_type=${supplier_type}&city=${city}`;
  };

  useEffect(() => {
    getEntityDetails();
  }, [currentPage]);

  // const backButton = () => {
  //   return (


      // <BackButton
      //   onClick={() =>
      //     navigate(`/r/operations-dashboard/city/${supplier_type}`, {
      //       state: { supplier_type: supplier_type, name: supplier_type },
      //     })
      //   }
      // />
  //   );
  // };
      const backButton = () => {
        return <BackButton onClick={() =>
          navigate(`/r/operations-dashboard/city/${supplier_type}`, {
            state: { supplier_type: supplier_type, name: supplier_type },
          })
        } />;
      };


  return (
    <>
      <TableHeader headerValue={`List of ${supplier_type} Entities of ${city}`} isBackButton={backButton} />
      <div className="page-title-header-right">
        <div className="upload-wrapper">
          <label>Upload Area/Subarea Excel </label>
          <div className="input_container" title="Upload Area/Subarea Excel">
            <input type="file" id="upload_file" onChange={(e) => fileUpload(e)} />
          </div>
        </div>
        <div>
          <Button
            color="primary"
            onClick={() => {
              downloadSupplierData();
            }}
          >
            Export CSV
          </Button>
        </div>
      </div>
      <div>
        {isDataFetched ? (
          <div>
            <CommonTable
              id={'supplier_id'}
              columnsData={getEntityList(entityDetails)}
              rowData={entityDetails}
            />
            <ReactPagination
              pageNo={currentPage}
              pageSize={10}
              totalItems={totalSize}
              onPageChange={handleTableChange}
            />
          </div>
        ) : (
          <LoadingWrapper />
        )}
      </div>
    </>
  );
}
